import { render, staticRenderFns } from "./ForumPosts.vue?vue&type=template&id=dc2b35c6&"
import script from "./ForumPosts.vue?vue&type=script&lang=js&"
export * from "./ForumPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports